import { type RequestContext } from '~/types/RequestContext';

import {
	BettingInsightsElasticSearch,
	type BettingInsightsElasticSearchConfig,
} from './elasticsearch/BettingInsightsElasticSearch';
import {
	BettingInsightsUI,
	type BettingInsightsUIConfig,
} from './ui/BettingInsightsUI';
import { BettingInsightsComponent } from './BettingInsightsConfiguration';
import { type EsIndex } from './types';

export interface BettingInsightsConfig<TIndex extends EsIndex> {
	elasticSearch: BettingInsightsElasticSearchConfig<TIndex>;
	ui: BettingInsightsUIConfig<TIndex>;
}

export class BettingInsights<TIndex extends EsIndex>
	extends BettingInsightsComponent
	implements BettingInsightsConfig<TIndex>
{
	elasticSearch: BettingInsightsElasticSearch<TIndex>;
	ui: BettingInsightsUI<TIndex>;

	constructor({
		elasticSearch,
		ui,
		...requestContext
	}: BettingInsightsConfig<TIndex> & RequestContext) {
		super(requestContext);
		this.elasticSearch =
			BettingInsightsElasticSearch.withRequestContext<TIndex>(
				requestContext,
				elasticSearch,
			);
		this.ui = BettingInsightsUI.withRequestContext<TIndex>(requestContext, ui);
	}

	static withRequestContext<TIndex extends EsIndex>(
		requestContext: RequestContext,
		config: BettingInsightsConfig<TIndex>,
	) {
		return new this<TIndex>({
			...requestContext,
			...config,
		});
	}
}
